import { CustomAppLevel, CustomAppConfig } from '../../types/customApps';
import { ReplitIntegration } from '../reducers/tools/ReplitReducer';

export interface CustomAppWithDisplay extends ReplitIntegration {
  displayName: string;
  displayOrder: number;
}

/**
 * Filters and sorts custom apps by level and entity.
 * Returns apps with displayName and displayOrder properties.
 */
export const getCustomAppsForLevel = (
  integrations: ReplitIntegration[],
  configs: CustomAppConfig[],
  level: CustomAppLevel,
  entityId?: number
): CustomAppWithDisplay[] => {
  if (integrations.length === 0 || configs.length === 0) {
    return [];
  }

  const enabledConfigs = configs.filter(
    config =>
      config.level === level &&
      config.is_enabled &&
      (entityId === undefined ||
        config.entity_id === entityId ||
        config.entity_id === null ||
        config.entity_id === undefined)
  );

  if (enabledConfigs.length === 0) return [];

  const enabledAppIds = enabledConfigs.map(config => config.app_id);
  const filteredApps = integrations.filter(integration => enabledAppIds.includes(integration.id));

  return filteredApps
    .map(app => {
      const config = enabledConfigs.find(c => c.app_id === app.id);
      return {
        ...app,
        displayOrder: config?.display_order || 999,
        displayName: config?.display_name || app.app_id,
      };
    })
    .sort((a, b) => a.displayOrder - b.displayOrder);
};
